var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hr-wrapper"},[_c('hr',{staticClass:"custom-hr"}),_c('img',{staticClass:"monochrome-logo",attrs:{"src":require("@/assets/img/monochrome-logo.png"),"alt":"monochrome logo"}}),_c('hr',{staticClass:"custom-hr"})])
}]

export { render, staticRenderFns }